/** The operator on a node in a filter expression. */ export var ExpressionOperator = /*#__PURE__*/ function(ExpressionOperator) {
    ExpressionOperator["And"] = "and";
    ExpressionOperator["Or"] = "or";
    ExpressionOperator["Equals"] = "equals";
    ExpressionOperator["In"] = "in";
    ExpressionOperator["Substring"] = "substring";
    return ExpressionOperator;
}({});
/** The `field` token meaning "every field". */ export const allFieldsToken = "*";
/** Tags a custom field definition id in `field`. */ export const customFieldPrefix = "customField.";
